import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Error404Page from './views/Error404Page'
import CreateAccountPassword from './views/CreateAccountPassword'
import Reset from './views/Reset'
import NotificationDetail from './views/NotificationDetail'
import ProfileDashboard from './views/ProfileDashboard'
import Company from './views/Company'
import AddCompany from './views/AddCompany'
import Message from './views/Message'
import Feeds from './views/Feeds'
import Lia from "./views/Lia"
import Network from './views/Network'
import Search from './views/Search'
import Notifications from './views/Notifications'
import VSearch from './views/Search'
import GetStarted from './views/wizard'
import Invitation from './views/Invitation'
import InvitationAccount from './views/InvitationAccount'
import InvitationWizard from '@/views/InvitationWizard.vue';
import ProfileEdit from './views/ProfileEdit'
import PurchaseCompany from "./views/PurchaseCompany";
import CompanyAdmin from "./views/CompanyAdmin";
import SearchPage from "./views/SearchPage";
import ErrorPage from "./views/ErrorPage";
import CvPage from "./views/CvPage";
import SignupPage from "./views/SignupPage";
import Customers from "./views/CustomerProfile";
import CustomersSettings from "@/components/Customer/Settings.vue";
import Solver from "./views/Solver";
import Settings from "@/components/Consultant/Settings.vue";
import UserProfile from "./views/UserProfile";
import AcceptEnvitation from "./views/AcceptEnvitation.vue";
import TokenRedirect from "./components/helper/TokenRedirect";
import AccountActivation from "./views/AccountActivation.vue";
import CompanyProfile from "./views/CompanyProfile.vue";
import CompanySettings from "@/components/Company/Settings.vue"
import NotificationAssignmentDetails from "@/views/NotificationAssignmentDetails.vue";
import WizardAiProfile from "@/views/WizardAiProfile.vue";
import NotificationPitchDetails from "@/views/NotificationPitchDetails.vue";
import AccountConsultantProfile from "@/views/ConsultantProfile.vue";
import ProjectVerification from "@/views/ProjectVerification.vue";
import EmploymentVerification from "@/views/EmploymentVerification.vue";
import PitchInvitationView from "@/views/PitchInvitationView.vue";
import AiChangePassword from "@/views/AiChangePassword.vue"
import LandingHome from "@/views/LandingHome.vue";
import LandingAbout from './views/LandingAbout';
import LandingWP from "@/views/LandingWP.vue"
import ProfileMergeNotificationDetails from "@/views/NotificationDetailsProfileMerge.vue"

import TermsConditions from "@/views/TermsConditions.vue"

// Candidate
import InvitationStudentWizard from "@/views/InvitationStudentWizard.vue";
import InvitationInstructorWizard from "@/views/InvitationInstructorWizard.vue";
import InternshipNotification from "@/views/NotificationInternship.vue";
import NotificationSurvey from "@/views/NotificationSurvey.vue"

import AppliedInternshipNotificationView from "@/views/NotificationInternshipView.vue"


import CRM from "@/views/CRM.vue"

// Admin components
import AdminCreateAccounts from "@/views/admin/SignupPage.vue";
import StaffSignupCreator from "@/views/admin/StaffSignupCreator.vue"
import ConsultantPublicProfile from '@/components/public-profile/ConsultantPublicProfile.vue'
import CustomerPublicProfile from '@/components/public-profile/CustomerPublicProfile.vue'
import AssignmentPublicProfile from "@/components/public-profile/AssignmentPublicProfile.vue";
import SupplierPublicProfile from "@/components/public-profile/SupplierPublicProfile.vue"

// Resume
import Resume from "@/views/Resume/index.vue"

import Questionnaire from "@/views/Questionnaire.vue"

import CompanyCrm from "@/views/crm/index.vue"

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'welcome',
            component: LandingWP
        },
        {
            path: '/about-us',
            name: 'landing_about',
            component: LandingAbout
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/social-login/:provider?/:id?',
            name: 'log-token',
            component: TokenRedirect
        },
        {
            path: '/accept-envitation',
            name: 'accept-envitation',
            component: AcceptEnvitation
        },
        {
            path: '/get-started',
            name: 'get-started',
            component: GetStarted
        },
        {
            path: '/signup/:type?/:action?',
            name: 'signup',
            component: SignupPage
        },
        {
            path: '/create-password',
            name: 'create-password',
            component: CreateAccountPassword
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: Reset
        },
        {
            path: '/ai/make/profile',
            name: 'forgot-password',
            component: WizardAiProfile
        },
        {
            path: '/profile',
            name: 'user-profile',
            component: ProfileDashboard,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/profile/consultant/:type?',
            name: 'consultant-profile',
            component: AccountConsultantProfile,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/profile/customer/:type?',
            name: 'profile-customer',
            component: Customers,
            meta: {
                requiresAuth: false,
            }
        },
        {

            path: '/profile/customer/settings',
            name: 'customer-settings',
            component: CustomersSettings,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/settings/:tab?',
            name: 'settings',
            component: Settings,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/notification/:id/view/:direct?',
            name: 'notification-view',
            component: NotificationDetail,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/notification/internships/applied/:id/:not_id',
            name: 'applied-internship-notification-view',
            component: AppliedInternshipNotificationView,
            meta: {
                requiresAuth: true,
            }
        },

        {
            path: '/notification/view/pitch/:not_id/:id/:manager_id',
            name: 'company-details-pitching',
            component: NotificationPitchDetails,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/notification/view/assingment/:not_id/:id/:manager_id',
            name: 'assignment-notification-view',
            component: NotificationAssignmentDetails,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/notifications/merge/:id/:not_id',
            name: 'profile-merge-notification-view',
            component: ProfileMergeNotificationDetails,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/user/profile/:id/:type?',
            name: 'user-view-profile',
            component: UserProfile,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/user/cv/:id',
            name: 'user-cv',
            component: CvPage,
        },
        {
            path: '/profile/edit/:id',
            name: 'profile-edit',
            component: ProfileEdit,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/user/view/:id',
            name: 'profile-view',
            component: ConsultantPublicProfile,
            meta: {
                requiresAuth: true,
            }
        },
        // Public profile
        {
            path: '/public/consultant/:name',
            name: 'consultant-public-profile',
            component: ConsultantPublicProfile,
        },
        {
            path: '/public/customer/:name',
            name: 'customer-public-profile',
            component: CustomerPublicProfile,
        },
        {
            path: '/public/assignment/:name',
            name: 'assignment-public-profile',
            component: AssignmentPublicProfile,
        },
        {
            path: '/public/supplier/:name',
            name: 'supplier-public-profile',
            component: SupplierPublicProfile,
        },
        // End of public profile
        {
            path: '/search/people',
            name: 'search-people',
            component: SearchPage,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/search/company',
            name: 'search-people-company',
            component: SearchPage,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/search/skills',
            name: 'search-skills',
            component: SearchPage,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/company/:id',
            name: 'company-profile',
            component: Company,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/company/:id/purchase',
            name: 'purchase-company',
            component: PurchaseCompany
        },
        {
            path: '/company/:id/management',
            name: 'company-admin',
            component: CompanyAdmin
        },
        {
            path: '/addcompany',
            name: 'add-company',
            component: AddCompany,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/messages',
            name: 'messages',
            component: Message,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/resume',
            name: 'resume',
            component: Resume,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/feeds/:tag?',
            name: 'feeds',
            component: Feeds,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/lia',
            name: 'lia',
            component: Lia,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/questionnaire/:survey_id',
            name: 'questionnaire-forms',
            component: Questionnaire,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/tags/:tag',
            name: 'tags',
            component: Solver,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/error/:type?',
            name: 'error',
            component: ErrorPage,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/network',
            name: 'network',
            component: Network,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/notifications',
            name: 'notifications',
            component: Notifications,
            meta: {
                // requiresAuth: true,
            }
        },
        {
            path: '/sear',
            name: 'sear',
            component: VSearch,
            children: [{
                path: 'people',
                component: VSearch,
                name: 'people_search'


            },
            {
                path: 'content',
                component: VSearch,
                name: 'content_search'
            }
            ]


        },
        {
            path: '/search/:query',
            name: 'search',
            component: Search,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/profile/company',
            name: 'companyprofile',
            component: CompanyProfile,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/profile/company/settings',
            name: 'companySettings',
            component: CompanySettings,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/invitation',
            name: 'invitation',
            component: Invitation
        },
        {
            path: '/project/verification/issuer/:issuer/reference/:project',
            name: 'project-verification',
            component: ProjectVerification
        },
        {
            path: '/employment/verification/issuer/:issuer/reference/:employment',
            name: 'employment-verification',
            component: EmploymentVerification
        },
        {
            path: '/invitation',
            name: 'invitation',
            component: Invitation
        },
        {
            path: '/invitation/wizard',
            name: 'invitation_wizard',
            component: InvitationWizard
        },
        {
            path: "/invitation/account/:type",
            name: 'invitation_account',
            component: InvitationAccount
        },
        {
            path: "/account/activation",
            name: 'account_activation',
            component: AccountActivation
        },
        {
            path: '/invitation/pitch/view/:invitation_id/:pitch_id/:manager_id',
            name: 'pitch-invitation-view',
            component: PitchInvitationView
        },
        {
            path: '/ai/after/change/password/:token',
            name: 'Ai-change-password',
            component: AiChangePassword
        },
        {
            path: '/page-not-found',
            name: 'pageNotFound',
            component: Error404Page
        },
        {
            path: '/admin/create/account/:account_type?/:email?',
            name: 'addmin-create-accounts',
            component: AdminCreateAccounts
        },
        {
            path: '/admin/staff/create/account',
            name: 'staff-create-accounts',
            component: StaffSignupCreator
        },
        {
            path: '/crm',
            name: 'crm',
            component: CRM
        },
        {
            path: '/comp/crm/:tab?',
            name: 'company-crm',
            component: CompanyCrm
        },
        {
            path: '/student/invitation/:token',
            name: 'student-invitation',
            component: InvitationStudentWizard
        },
        {
            path: '/instructor/invitation/:token',
            name: 'instructor-invitation',
            component: InvitationInstructorWizard
        },
        {
            path: '/notification/internship/:not_id/:user_id/:ref_id/:copy_id',
            name: 'view_internship_notification',
            component: InternshipNotification
        },
        {
            path: '/notification/survey/:not_id/:user_id/:ref_id/:copy_id',
            name: 'view_survey',
            component: NotificationSurvey
        },
        {
            path: '/terms-conditions',
            name: 'terms-conditions',
            component: TermsConditions
        },
        {
            path: '*',
            redirect: '/page-not-found'
        },
    ]
});